(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('modele-contrat.type-tax', {
            url: '/type-tax/',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION', 'ROLE_READ_ONLY'],
                authenticate: true
            },
            views: {
                'panneau@content': {
                    templateUrl: 'app/business/type-tax/type-taxs.html',
                    controller: 'TypeTaxController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeTax');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('serviceVendu');
                    return $translate.refresh();
                }]
            }
        })
        .state('modele-contrat.type-tax.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-tax/type-tax-dialog.html',
                    controller: 'TypeTaxDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                taxRate: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('modele-contrat.type-tax', null, { reload: true });
                }, function() {
                    $state.go('modele-contrat.type-tax');
                });
            }]
        })
        .state('modele-contrat.type-tax.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-tax/type-tax-dialog.html',
                    controller: 'TypeTaxDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TypeTax', function(TypeTax) {
                            return TypeTax.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('modele-contrat.type-tax', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('modele-contrat.type-tax.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-tax/type-tax-delete-dialog.html',
                    controller: 'TypeTaxDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TypeTax', function(TypeTax) {
                            return TypeTax.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('modele-contrat.type-tax', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('type-tax', {
            parent: 'entity',
            url: '/type-tax?page&sort&search',
            data: {   
                authorities: ['ROLE_AREA_CONFIGURATION', 'ROLE_READ_ONLY'],
                authenticate: true,
                pageTitle: 'wamasysApp.typeTax.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/type-tax/type-taxs.html',
                    controller: 'TypeTaxController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeTax');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('serviceVendu');
                    return $translate.refresh();
                }]
            }
        })
        .state('type-tax-detail', {
            parent: 'entity',
            url: '/type-tax/{id}',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION', 'ROLE_READ_ONLY'],
                authenticate: true,
                pageTitle: 'wamasysApp.typeTax.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/type-tax/type-tax-detail.html',
                    controller: 'TypeTaxDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('typeTax');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TypeTax', function($stateParams, TypeTax) {
                    return TypeTax.get({id : $stateParams.id});
                }]
            }
        })
        .state('type-tax.new', {
            parent: 'type-tax',
            url: '/new',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-tax/type-tax-dialog.html',
                    controller: 'TypeTaxDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                label: null,
                                taxRate: null,
                                deleted: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('type-tax', null, { reload: true });
                }, function() {
                    $state.go('type-tax');
                });
            }]
        })
        .state('type-tax.edit', {
            parent: 'type-tax',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-tax/type-tax-dialog.html',
                    controller: 'TypeTaxDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TypeTax', function(TypeTax) {
                            return TypeTax.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-tax', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('type-tax.delete', {
            parent: 'type-tax',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/type-tax/type-tax-delete-dialog.html',
                    controller: 'TypeTaxDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TypeTax', function(TypeTax) {
                            return TypeTax.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('type-tax', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
